import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

/**
 * -----------------------------------------------------------------------------
 * Get list of training modules
 * -----------------------------------------------------------------------------
 */

export type TrainingModuleListItem = {
  trainingModuleId: string
  program: {
    id: string
    code: string
    displayName: string
    operatorDisplayName: string
    color: string
    iconId: string
    instructions: string
    labelSet: string[]
    responseSet: string[]
    targetAccuracy: number
    targetSpeed: number
    engagementLevelAnnotations: boolean
    engagementLifetime: number
    extendedFeedback: boolean
    liveFeedbackEnabled: boolean
    operatorRoleRequirement: boolean
    escalations: string[]
    trainingFeedbacks: {
      trainingFeedbackId: string
      type: string
      label: string
      feedback: string
    }[]
  }
  title: string
  description: string
  engagementCount: number
  isPublished: boolean
  trainingOrder: number
  accuracyMin: number
  accuracyMax: number
  targetResolution: number
  targetAccuracy: number
  overallMaxAttempts: number
  dailyMaxAttempts: number
  isCompleted: boolean
  bestAccuracy: number
  bestSpeed: number
  specialistAttemptsToday: number
  specialistAttemptsOverall: number
}

export function useModulesList(programId?: string, enabled = true) {
  return useQuery({
    queryKey: ['training-modules', programId],
    queryFn: async () => {
      const root = `/int/v2/mission-specialist/training-modules/mine`

      const response = await apiClient.get<TrainingModuleListItem[]>(
        programId ? `${root}?program_id=${programId}` : root
      )
      return response.data
    },
    refetchOnWindowFocus: false,
    enabled,
  })
}

/**
 * -----------------------------------------------------------------------------
 * Atttempts stats
 * -----------------------------------------------------------------------------
 */
type GetTrainingModuleAttemptsStatsResponse = {
  module: {
    maximumOverallAttempts: number
    maxiumDailyAttempts: number
  }
  currentOverralAttempts: number
  currentDailyAttempts: number

  hasReachedMaximumDailyOrOverallAttempts: boolean
}

export function useAttemptsStats(trainingModuleId?: string) {
  return useQuery({
    queryKey: ['training-modules-attempts-stats', trainingModuleId],
    queryFn: async () => {
      const { data } = await apiClient.get<GetTrainingModuleAttemptsStatsResponse>(
        `int/v2/mission-specialist/training-modules/${trainingModuleId}/attempts-stats`
      )
      return data
    },
    enabled: Boolean(trainingModuleId),
  })
}
